import React from "react";

export default function TrombinosSkeletonList() {
  return (
    <div className="grid gap-4 p-4 sm:p-5 xl:grid-cols-2 2xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[1.7rem] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="h-48 animate-pulse bg-slate-200 dark:bg-slate-800" />

          <div className="p-5">
            <div className="h-7 w-40 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="mt-4 h-6 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

            <div className="mt-5 space-y-2">
              <div className="h-3 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-3 w-5/6 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-3 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            </div>

            <div className="mt-5 flex gap-2">
              <div className="h-10 w-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-10 w-24 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-10 w-24 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}